import React from "react";
import { useRouteMatch, Switch, Route } from "react-router-dom";
import { ManageUnitRoles } from "../domain/userRole";
import { useAuth } from "@ofqual/portal-core/core/hooks";
import { ProtectedRoute } from "@ofqual/portal-components/components/ProtectedRoute";
import { NewItem } from "./create/NewItem";
import { Item } from "./item/Item";
import { Items } from "./list/Items";
import { authSelector } from "../redux/selectors";

export const Component: React.FC = () => {
  const { path } = useRouteMatch();
  const { isInRole } = useAuth(authSelector);

  return (
    <Switch>
      <Route path={path} exact>
        <Items />
      </Route>

      <ProtectedRoute
        path={`${path}/new`}
        exact
        check={() => isInRole(...ManageUnitRoles)}
      >
        <NewItem />
      </ProtectedRoute>

      <Route path={`${path}/:id`}>
        <Item />
      </Route>
    </Switch>
  );
};
